import BunnyVideoPlayer from "./BunnyVideoPlayer";

export default BunnyVideoPlayer;